import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid, GridSearchItem, ServiceSearchItem} from '../../../../shared/Models/grid';
import {Router} from '@angular/router';
import {ProductService} from '../../../Services/product.service';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {ActionColumn, ActionItem, NumberColumn, TextColumn} from '../../../../shared/Models/columns';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-archive-product-view',
  templateUrl: './archive-product-view.component.html',
  styleUrls: ['./archive-product-view.component.scss']
})
export class ArchiveProductViewComponent implements OnInit {

  public grid: Grid;
  public productId: number;
  public productName: string;
  @ViewChild('collectionRowDetail', {static: true}) collectionRowDetail: any;
  @ViewChild('priceTemp', {static: true}) priceTemp;
  @ViewChild('customerPriceTemp', {static: true}) customerPriceTemp;
  @ViewChild('readdModal', {static: false}) readdModal = null;

  constructor(
    private router: Router,
    private productService: ProductService,
    private broadCastService: BroadcastService,
    private translate: TranslateService
  ) {
  }

  ngOnInit() {
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.product.name',
          prop: 'name',
          sortable: true,
          type: TextColumn.type,
          width: 250,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.model.model',
          prop: 'models',
          type: TextColumn.type,
          width: 200,
          translate: true,
          valueFormatter: row => {
            const items = [];
            row.forEach(item => {
              items.push(item.name);
            });
            return items.join(',');
          },
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.product.number',
          prop: 'number',
          type: TextColumn.type,
          width: 200,
          translate: true,
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.product.dealer_price',
          prop: 'dealerPrice',
          type: TextColumn.type,
          translate: true,
          valueTemplate: this.priceTemp,
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.product.customer_price',
          prop: 'customerPrice',
          type: TextColumn.type,
          translate: true,
          valueTemplate: this.customerPriceTemp,
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.product.type',
          prop: 'hasProduct',
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => {
            if (row) {
              return this.translate.instant('admin.product.grouped_product');
            }
            return this.translate.instant('admin.product.product');
          },
        },
        <TextColumn>{
          name: 'doctrine.product.status',
          prop: 'status',
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => {
            if (row) {
              return this.translate.instant('global.active');
            }
            return this.translate.instant('global.inactive');
          },
          responsiveHideCallback: (width) => width < 1024
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'feather icon-plus',
              tooltip: 'global.readd',
              onclick: row => {
                this.productId = row.id;
                this.productName = row.name.bold();
                this.readdModal.show();
              },
              showCallback: row => row,
              btnClass: 'ripple light'
            },
          ]
        }
      ],
      service: this.productService,
      rememberURL: this.router.url,
      method: 'getProduct',
      defaultSort: 'name',
      rowDetailTemplate: this.collectionRowDetail,
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true,
      archive: true,
      doseNotHaveSearch:true,
      search: [
        <GridSearchItem>{
          name: 'model_id',
          type: 'ng-select',
          label: 'doctrine.attributes.model',
          hasDropdownListFilter: true,
          hasNormalSearch:true,
          value: new ServiceSearchItem(this.productService, 'getModals', {sortType: 'ASC', sortBy: 'name'}, (res) => {
            const options = [];
            for (const row of res.data) {
              options.push({value: row.id, label: row.name});
            }
            return options;
          })
        }
      ],
    };

  }

  public readd() {
    this.productService.readdProduct(this.productId).subscribe((res) => {
      this.broadCastService.broadcast('refreshGrid', 'getProduct');
      this.readdModal.hide();
    });
  }

  goToProductOverview() {
    this.router.navigateByUrl('back-office/product/overview');
  }
}
